import {
  CO2Response,
  ConseilResponse,
  ConsoResponseWithYearlyAverage,
  MedianeResponse,
  ObjectifResponse,
} from "../../typings/types";
import sendPostRequest from "./sendPostRequest";
import * as timeToolbox from "./utils";
import * as requestTypeFromGlossaire from "../../references/glossaire_requetes";

const date_auj_00_00 = timeToolbox.getCurrentDateAtMidnightUTC();
const time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getMediane = (type_id: number): Promise<MedianeResponse> => {
  const params = {
    type_id,
    time_zone,
    date_median_max: date_auj_00_00,
    request_type: requestTypeFromGlossaire.mediane_max_pour_un_type_sur_30j,
  };
  return sendPostRequest(params);
};

export const getCO2 = (
  type_id: number,
  req: { frequence: number; start_interval: number; end_interval: number }
): Promise<CO2Response> => {
  const { frequence, start_interval, end_interval } = req;
  const params = {
    type_id,
    frequence,
    start_interval,
    end_interval,
    request_type: requestTypeFromGlossaire.recuperer_liste_des_debit_par_type,
    time_zone,
  };
  return sendPostRequest(params);
};

export const getConsommation = (
  sensor_id: number,
  req: { frequence: number; start_interval: number; end_interval: number }
): Promise<ConsoResponseWithYearlyAverage> => {
  const { frequence, start_interval, end_interval } = req;
  const params = {
    sensor_id,
    frequence,
    start_interval,
    end_interval,
    request_type: requestTypeFromGlossaire.recuperer_liste_des_debit_d_un_engin,
    time_zone,
  };
  return sendPostRequest(params);
};

export const getObjectif = (
  sensor_id: number,
  req: { frequence: number; start_interval: number; end_interval: number }
): Promise<ObjectifResponse> => {
  const { frequence, start_interval, end_interval } = req;
  const params = {
    sensor_id,
    frequence,
    start_interval,
    end_interval,
    request_type: requestTypeFromGlossaire.recuperer_le_cumule_d_un_engin,
    time_zone,
  };
  console.log(params);
  return sendPostRequest(params);
};

export const getConseil = (
  sensor_id: number,
  req: { frequence: number; start_interval: number; end_interval: number }
): Promise<ConseilResponse> => {
  const { frequence, start_interval, end_interval } = req;
  const params = {
    sensor_id,
    frequence,
    start_interval,
    end_interval,
    request_type:
      requestTypeFromGlossaire.recuperer_les_donnees_de_fonctionnement_et_de_ralenti_par_engin,
    time_zone,
  };
  return sendPostRequest(params);
};
